<template>
  <div class="mainpage">
    <div class="head">
      <div class="head-title">{{ type }}实验报告</div>
      <div class="retutnbt" @click="toback">返回</div>
    </div>
    <div class="line"></div>
    <div class="maincontain">
      <el-form
        class="elform"
        ref="form"
        :rules="rules"
        :model="form"
        label-width="80px"
      >
        <el-form-item class="elinput" label="标题:" prop="title">
          <el-input
            :disabled="type == '编辑'"
            v-model="form.title"
            placeholder="请输入(20字以内)"
          ></el-input>
        </el-form-item>
        <el-form-item class="elinput" label="实验课程:">
          <span style="color: #353535">{{ parent.course_lib_name }}</span>
          <!-- <el-select v-model="form.related_id" clearable placeholder="请选择">
            <el-option v-for="item in optionone" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>-->
        </el-form-item>
        <el-form-item class="elinput" label="实验项目:">
          <el-select
            v-model="form.experiment_id"
            @change="handleProject"
            clearable
            placeholder="请选择"
          >
            <template v-if="optiontwo && optiontwo.length > 0">
              <el-option
                v-for="item in optiontwo"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item class="elinput" label="报告模板:">
          <span @click="handlePreview" style="color: #3470EE;cursor: pointer;">{{ form.report_url }}</span>
        </el-form-item>
        <el-form-item
          class="elinput2"
          label="报告规范要求:"
          prop="report_requirements"
          label-width="110px"
        >
          <div class="text-editor">
            <span>{{ form.report_requirements }}</span>
          </div>
        </el-form-item>
        <el-form-item
          class="elinput2"
          label="实验报告:"
          prop="content"
          label-width="88px"
        >
          <div class="text-editor">
            <Tinymce
              ref="editor"
              v-model="form.content"
              style="height: auto; border-radius: 22px; font-size: 12px"
              @setInput="getValue"
            ></Tinymce>
          </div>
        </el-form-item>

        <el-form-item class="elinput" label="附件">
          <UploadFiles
            :files="fileList"
            :module="'practice_report,url'"
            :cloudType="'PracticeReport/url'"
            @setUrl="getUrl"
          />
          <el-button type="primary" size="small" style="display: block;margin: 20px 0 0;" @click="handleRecord">上传录像</el-button>
          <div v-for="(item,index) in recordList" :key="index" class="video-box">
            <div class="video-name">{{ item.camera_name }}</div>
            <img class="video-img" @click="handleDel(item,index)" src="@/assets/删除_d.png" />
          </div>
        </el-form-item>
      </el-form>
      <div class="bts">
        <el-button type="primary" plain @click="toback()">取消</el-button>
        <el-button type="primary" @click="savebt('form')">保存</el-button>
        <el-button type="primary" @click="submitbt('form')">提交</el-button>
      </div>
    </div>

    <!-- 上传实操回顾弹框 -->
    <operateRecord :visible.sync="recordVisible" ref="recordChild" @updRecord="updRecord"></operateRecord>

  </div>
</template>

<script>
import { getmyarrangedlist } from "@/api/courselibtimetable";
import { getexperimentlist } from "@/api/experiment";
import {
  addexperimentreport,
  editexperimentreport,
  getexperimentreportinfo,
  courseLibGetInfo
} from "@/api/experimentreport";

import Tinymce from "@/components/VueTinymce/index.vue";
import UploadFiles from "@/components/upload-files.vue";
import { rules } from "eslint-plugin-prettier";
import operateRecord from "./components/operateRecord.vue";
export default {
  name: "mainpage",
  components: {
    UploadFiles,
    Tinymce,
    operateRecord
  },
  data() {
    return {
      form: {
        id: "",
        title: "",
        content: "",
        related_id: "",
        type: 0,
        report_requirements: "",
        experiment_id: "",
        report_url: '',
        action: "",
        file: "",
      },
      optionone: [],
      optiontwo: [],
      fileList: [],
      type: "新增",
      parent: "", // 父级传参
      rules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        content: [
          { required: true, message: "请输入实验报告", trigger: "blur" },
        ],
      },
      course_lib_sn: "",
      recordVisible: false,//上传实操回顾弹框
      recordList: [],//上传录像数组
    };
  },
  computed: {},
  created() {
    this.parent = {
      semester_id: this.$route.query.semester_id || "",
      course_lib_id: this.$route.query.course_lib_id || "",
      course_lib_name: this.$route.query.course_lib_name || "",
      course_lib_sn: this.$route.query.course_lib_sn || "",
    };
    this.course_lib_sn = this.$route.query.course_lib_sn || "";
    this.form.related_id = this.parent.course_lib_id; // 实验课程ID
    this.type = this.$route.query.type ? this.$route.query.type : "新增";
    if (this.type == "编辑") {
      // let info = JSON.parse(decodeURIComponent(this.$route.query.info));
      this.form.id = this.$route.query.id || "";
      this.getReportInfo({ id: this.$route.query.id }); //获取实验报告详情
    }
    // this.getMyArrangedList(); //获取教学实验课列表
    this.getExperimentList(); //获取实验项目列表
    this.courseLibGetInfo();
  },
  methods: {
    // 预览模版
    handlePreview(){
      window.open(this.form.report_url)
    },
    //实验项目下拉
    handleProject(e){
      if(e == ''){
        this.form.report_url = ''
      }
      this.optiontwo.map((item,index)=>{
        if(item.id == e){
          this.form.report_url = item.report_url
        }
      })
    },
    //上传录像
    handleRecord(){
      this.$refs.recordChild.loadObj()
      this.recordVisible = true;
    },
    handleDel(item,index){
      this.recordList.splice(index,1);
    },
    updRecord(data){
      this.recordVisible = false
      if(data && data.length){
        this.recordList = this.recordList.concat(data)
      }
    },
    //获取实验报告详情
    getReportInfo(params) {
      getexperimentreportinfo(params)
        .then((response) => {
          if (response.data) {
            this.form.title = response.data.title;
            this.form.content = response.data.content.replace(/\\/g, "");
            this.form.related_id = response.data.related_id;
            this.form.report_requirements = response.data.report_requirements;
            this.form.experiment_id = response.data.experiment_id;
            this.form.report_url = response.data.report_url;
            this.form.file = JSON.stringify(response.data.file_list);
            this.fileList = response.data.file_list;
          }
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    courseLibGetInfo(){
      let params = { course_lib_sn: this.course_lib_sn };
      courseLibGetInfo(params)
        .then((response) => {
          if (response.code === 0) {
            this.form.report_requirements = response.data.report_requirements;
          }
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    //获取教学实验课列表
    getMyArrangedList() {
      let params = { semester_id: this.parent.semester_id };
      getmyarrangedlist(params)
        .then((response) => {
          if (response.code === 0) {
            this.optionone = response.data.data;
          }
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    //获取实验项目列表
    getExperimentList() {
      let params = { course_lib_id: this.parent.course_lib_id, is_portal: 1 };
      getexperimentlist(params)
        .then((response) => {
          if (response.code === 0) {
            this.optiontwo = response.data;
          }
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    toback() {
      this.$router.push({
        path: "/home/personalcenter/texperimentalreport",
        query: this.parent,
      });
    },
    //保存
    savebt(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = Object.assign({},this.form);
          form.action = 0; //保存
          delete form.report_url 
          if (this.type == "新增") {
            this.addexperimentreport(form);
          } else if (this.type == "编辑") {
            this.editexperimentreport(form);
          }
        }
      });
    },
    //提交
    submitbt(formName) {
      let arrList = []
      if(this.form.file && this.form.file.length){
        arrList = JSON.parse(this.form.file)
      }
      let transList = [];
      let recordList = this.recordList;
      for(let i in recordList){
        let lastDotIndex = recordList[i].file.lastIndexOf(".");
        let lastLineIndex = recordList[i].file.lastIndexOf("/");
        const urlStr = new URL(recordList[i].file);
        let recordObj = {
          ext: recordList[i].file.slice(lastDotIndex + 1),
          name: recordList[i].file.slice(lastLineIndex + 1),
          path: (urlStr.pathname + urlStr.search).slice(1),
          size: recordList[i].size,
          url: recordList[i].file,
        }
        transList.push(recordObj)
      }
      let form = Object.assign({},this.form)
      form.file = JSON.stringify(arrList.concat(transList))
      delete form.report_url 
      console.log(form,"参数管理",transList)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          form.action = 1; //提交
          if (this.type == "新增") {
            this.addexperimentreport(form);
          } else if (this.type == "编辑") {
            this.editexperimentreport(form);
          }
        }
      });
    },
    addexperimentreport(params) {
      addexperimentreport(params)
        .then((response) => {
          if (response.code === 0) {
            this.toback();
          }
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    editexperimentreport(params) {
      editexperimentreport(params)
        .then((response) => {
          if (response.code === 0) {
            this.toback();
          }
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    // 获取富文本得值
    getValue(data) {
      this.form.content = data;
    },
    // 获取文件上传的返回值
    getUrl(data, key) {
      this.form.file = data;
      this.fileList = JSON.parse(data);
    },
  },
};
</script>
<style scoped lang="scss">
.mainpage {
  // overflow: hidden;
  background: #ffffff;
  min-width: 1600px;
  // margin-top: 40px;
  .head {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .head-title {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #3d84ff;
      user-select: none;
      white-space: nowrap;
      margin-top: 10px;
      margin-left: 20px;
    }
    .retutnbt {
      margin-right: 40px;
      width: 64px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      background: #3d84ff;
      border-radius: 4px;
      color: white;
      user-select: none;
      cursor: pointer;
      margin-top: 10px;
      font-size: 14px;
    }
  }
  .line {
    margin-top: 10px;
    margin-bottom: 4px;
    border-bottom: 2px solid #cccccc;
  }
  .maincontain {
    // height: 1008px;
    background: #ffffff;
    border-radius: 4px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 20px;
    padding-bottom: 20px;
    .elform {
      // border: 1px solid red;
      .elinput {
        width: 30%;
      }
      .elinput2 {
        width: 80%;
      }
      .inputcontain {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .bt {
          padding: 0px;
          margin: 0px;
          margin-left: 10px;
          width: 64px;
          height: 38px;
          line-height: 38px;
          text-align: center;
          background: #ffffff;
          border: 1px solid #cccccc;
          border-radius: 4px;
          font-size: 14px;

          font-weight: 400;
          color: #a0a0a0;
          user-select: none;
          cursor: pointer;
        }
        .bt1 {
          background: #3d84ff;
          color: #ffffff;
        }
      }

      .text-editor {
        // border: 1px solid red;
      }
      .file-select-contain {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .file-selecttip {
          margin-left: 10px;
          padding-left: 10px;
          text-align: left;
          width: 200px;
          height: 40px;
          background: #ffffff;
          border: 1px solid #3d84ff;
          border-radius: 4px;
        }
        .file-selectbt {
          margin-left: 10px;
          font-size: 15px;
          font-weight: 400;
          color: #ffffff;
          width: 121px;
          height: 40px;
          line-height: 40px;
          padding: 0px;
          text-align: center;
          background: #3d84ff;
          border: 1px solid #3d84ff;
          border-radius: 4px;
          //  border: 1px solid red;
          &:active {
            background: #3d84ff;
          }
        }
      }
    }
    .bts {
      //   border: 1px solid red;
      margin-top: 40px;
      margin-right: 100px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .bt {
        margin-right: 10px;
        width: 64px;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background: #ffffff;
        border: 1px solid #cccccc;
        border-radius: 4px;
        font-size: 14px;

        font-weight: 400;
        color: #a0a0a0;
        user-select: none;
        cursor: pointer;
      }
      .bt1 {
        background: #3d84ff;
        color: #ffffff;
      }
    }
    .video-box{
      width: 100%;
      display: flex;
      .video-name{
        color: #333;
        font-size: 16px;
        line-height: 30px;
        width: 80%;
      }
      .video-img{
        width: 22px;
        height: 22px;
        margin: 4px 0 0;
        cursor: pointer;
      }
    }
  }
}
</style>
